import React from 'react';

const MatchDescriptionOddsTable = ({ eventDetails }) => {
  const {
    matchId, tournamentId, competition, round, playerOne, playerTwo,
  } = eventDetails;

  return (
    <div className="table-responsive m-t-30">
      <table className="match">
        <thead className="thead--green">
          <tr>
            <th className="match__th">Match ID</th>
            <th>Round</th>
            <th>Tournament ID</th>
            <th className="match__th">Competition</th>
            <th className="match__th">Player 1</th>
            <th className="match__th">Player 2</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{matchId}</td>
            <td>{round}</td>
            <td>{tournamentId}</td>
            <td>{competition}</td>
            <td>{playerOne}</td>
            <td>{playerTwo}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MatchDescriptionOddsTable;
